import React from 'react';
import { Image } from '../../../commonComponents';
import PropTypes from 'prop-types';

const images = {
  1: require('../../../../assets/imgs/new/step-1.png'),
  2: require('../../../../assets/imgs/new/step-2.png'),
  3: require('../../../../assets/imgs/new/step-3.png'),
  4: require('../../../../assets/imgs/new/step-4.png'),
  5: require('../../../../assets/imgs/new/step-5.png'),
};

const Steps = ({ arr, index }) => (
  <div className='tutorial-step-left'>
    {arr.length - 1 === index ? (
      <React.Fragment>
        <div className='top'>
          <Image className='img-responsive icon' src={images[index + 1]} />
        </div>
        <div className='bottom'>
          <Image className='img-responsive icon' src={images[index + 2]} />
        </div>
      </React.Fragment>
    ) : (
      <Image className='img-responsive icon' src={images[index + 1]} />
    )}
  </div>
);

Steps.propTypes = {
  arr: PropTypes.array,
  index: PropTypes.number,
};

export default Steps;
